import { css } from 'lit';

export const styles = css`
	:host {
		--_sds-heading-font-family: var(--sds-heading-font-family, var(--sds-typography-font-family-roboto));
		--_sds-heading-text-color: var(--sds-heading-text-color, var(--sds-color-text-default, var(--sds-color-neutral-text-default)));
		--_sds-heading-max-line-width: var(--sds-heading-max-line-width, var(--sds-typography-max-line-width));
		--_sds-heading-margin: var(--sds-heading-margin, 0);
		--_sds-heading-padding: var(--sds-heading-padding, 0);
		--_sds-heading-text-align: var(--sds-heading-text-align, left);

		--_sds-heading-font-size: var(--sds-heading-font-size, var(--sds-typography-heading-xl-mobile-font-size));
		--_sds-heading-font-weight: var(--sds-heading-font-weight, var(--sds-typography-font-weight-bold));
		--_sds-heading-line-height: var(--sds-heading-line-height, var(--sds-typography-heading-xl-mobile-line-height));

		display: inline-block;
	}

	:host([data-palette]) {
		--_sds-heading-text-color: var(--sds-heading-text-color, var(--sds-color-text-default, var(--sds-color-neutral-text-default)));
	}

	h1,
	h2,
	h3,
	h4,
	h5,
	h6,
	.sds-heading {
		color: var(--_sds-heading-text-color);
		display: inline-block;
		font-family: var(--_sds-heading-font-family);
		font-size: var(--_sds-heading-font-size);
		font-weight: var(--_sds-heading-font-weight);
		line-height: var(--_sds-heading-line-height);
		margin: var(--_sds-heading-margin);
		max-width: var(--_sds-heading-max-line-width);
		padding: var(--_sds-heading-padding);
		text-align: var(--_sds-heading-text-align);
	}

	h1,
	.sds-heading--xl {
		--_sds-heading-font-size: var(--sds-heading-font-size, var(--sds-typography-heading-xl-mobile-font-size));
		--_sds-heading-line-height: var(--sds-heading-line-height, var(--sds-typography-heading-xl-mobile-line-height));
	}

	@media (min-width: 640px) {
		h1,
		.sds-heading--xl {
			--_sds-heading-font-size: var(--sds-heading-font-size, var(--sds-typography-heading-xl-tablet-font-size));
			--_sds-heading-line-height: var(--sds-heading-line-height, var(--sds-typography-heading-xl-tablet-line-height));
		}
	}

	@media (min-width: 1024px) {
		h1,
		.sds-heading--xl {
			--_sds-heading-font-size: var(--sds-heading-font-size, var(--sds-typography-heading-xl-desktop-font-size));
			--_sds-heading-line-height: var(--sds-heading-line-height, var(--sds-typography-heading-xl-desktop-line-height));
		}
	}

	h2,
	.sds-heading--lg {
		--_sds-heading-font-size: var(--sds-heading-font-size, var(--sds-typography-heading-lg-mobile-font-size));
		--_sds-heading-line-height: var(--sds-heading-line-height, var(--sds-typography-heading-lg-mobile-line-height));
	}

	@media (min-width: 640px) {
		h2,
		.sds-heading--lg {
			--_sds-heading-font-size: var(--sds-heading-font-size, var(--sds-typography-heading-lg-tablet-font-size));
			--_sds-heading-line-height: var(--sds-heading-line-height, var(--sds-typography-heading-lg-tablet-line-height));
		}
	}

	@media (min-width: 1024px) {
		h2,
		.sds-heading--lg {
			--_sds-heading-font-size: var(--sds-heading-font-size, var(--sds-typography-heading-lg-desktop-font-size));
			--_sds-heading-line-height: var(--sds-heading-line-height, var(--sds-typography-heading-lg-desktop-line-height));
		}
	}

	h3,
	.sds-heading--md {
		--_sds-heading-font-size: var(--sds-heading-font-size, var(--sds-typography-heading-md-mobile-font-size));
		--_sds-heading-line-height: var(--sds-heading-line-height, var(--sds-typography-heading-md-mobile-line-height));
	}

	@media (min-width: 640px) {
		h3,
		.sds-heading--md {
			--_sds-heading-font-size: var(--sds-heading-font-size, var(--sds-typography-heading-md-tablet-font-size));
			--_sds-heading-line-height: var(--sds-heading-line-height, var(--sds-typography-heading-md-tablet-line-height));
		}
	}

	@media (min-width: 1024px) {
		h3,
		.sds-heading--md {
			--_sds-heading-font-size: var(--sds-heading-font-size, var(--sds-typography-heading-md-desktop-font-size));
			--_sds-heading-line-height: var(--sds-heading-line-height, var(--sds-typography-heading-md-desktop-line-height));
		}
	}

	h4,
	.sds-heading--sm {
		--_sds-heading-font-size: var(--sds-heading-font-size, var(--sds-typography-heading-sm-mobile-font-size));
		--_sds-heading-font-weight: var(--sds-heading-font-weight, var(--sds-typography-font-weight-semibold));
		--_sds-heading-line-height: var(--sds-heading-line-height, var(--sds-typography-heading-sm-mobile-line-height));
	}

	@media (min-width: 640px) {
		h4,
		.sds-heading--sm {
			--_sds-heading-font-size: var(--sds-heading-font-size, var(--sds-typography-heading-sm-tablet-font-size));
			--_sds-heading-line-height: var(--sds-heading-line-height, var(--sds-typography-heading-sm-tablet-line-height));
		}
	}

	@media (min-width: 1024px) {
		h4,
		.sds-heading--sm {
			--_sds-heading-font-size: var(--sds-heading-font-size, var(--sds-typography-heading-sm-desktop-font-size));
			--_sds-heading-line-height: var(--sds-heading-line-height, var(--sds-typography-heading-sm-desktop-line-height));
		}
	}

	h5,
	h6,
	.sds-heading--xs {
		--_sds-heading-font-size: var(--sds-heading-font-size, var(--sds-typography-heading-xs-mobile-font-size));
		--_sds-heading-font-weight: var(--sds-heading-font-weight, var(--sds-typography-font-weight-semibold));
		--_sds-heading-line-height: var(--sds-heading-line-height, var(--sds-typography-heading-xs-mobile-line-height));
	}

	@media (min-width: 640px) {
		h5,
		h6,
		.sds-heading--xs {
			--_sds-heading-font-size: var(--sds-heading-font-size, var(--sds-typography-heading-xs-tablet-font-size));
			--_sds-heading-line-height: var(--sds-heading-line-height, var(--sds-typography-heading-xs-tablet-line-height));
		}
	}

	@media (min-width: 1024px) {
		h5,
		h6,
		.sds-heading--xs {
			--_sds-heading-font-size: var(--sds-heading-font-size, var(--sds-typography-heading-xs-desktop-font-size));
			--_sds-heading-line-height: var(--sds-heading-line-height, var(--sds-typography-heading-xs-desktop-line-height));
		}
	}
`;
